import { API } from "aws-amplify";

async function attachDevice(streamId: string, device: Strobe): Promise<void> {
  const path: string = `/devices/attached/${streamId}`;
  const options = {
    body: device
  };

  try {
    await API.post('api-service', path, options);
  } catch (error: any) {
    throw error;
  }
}

export default attachDevice;